import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed",
  style: {"background-image":"url('media/svg/illustrations/progress.svg')"}
}
const _hoisted_2 = { class: "d-flex flex-column flex-column-fluid text-center p-10 py-lg-20" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"pt-lg-10\"><h1 class=\"fw-bolder fs-4x text-gray-700 mb-10\">Page Not Found</h1><div class=\"fw-bold fs-3 text-gray-400 mb-15\"> The page you looked not found! <br> Plan your blog post by choosing a topic </div><div class=\"text-center\"><a href=\"/\" class=\"btn btn-lg btn-primary fw-bolder\">Go to homepage</a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Logo, { class: "w-20 mx-auto" }),
      _hoisted_3
    ]),
    _createVNode(_component_Footer, { containerClass: "w-100 border" })
  ]))
}